export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/object-storage-service-stack-form';
